import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { XUXDrawerModule } from './xux-drawer';
import { XUXMenuPinnedService } from './services/xux-menu-pinned.service';
import { XUXDrawerSidebarService } from './services/xux-drawer-sidebar.service';
import { XUXBreadcrumbNavbarComponent } from './xux-breadcrumb-navbar/xux-breadcrumb-navbar.component';
import { DmComponentsModule } from '../components/dm.components.module';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { datePickerComponents } from './xux-datepicker';
import { XuxDatepickerLayoutComponent } from './xux-datepicker/xux-datepicker-layout/xux-datepicker-layout.component';
import { XuxDatepickerInputComponent } from './xux-datepicker/xux-datepicker-input/xux-datepicker-input.component';
import { XuxIconComponent, XuxIconDefsComponent } from './xux-icons';
import { XuxModalInputComponent } from '@xenial-ux/xux-modal-input/xux-modal-input.component';
import { FocusElementModule } from '@directives/focus-element/focus-element.module';
import { XuxSearchInputComponent } from '@xenial-ux/xux-search-input/xux-search-input.component';
import { XuxInputSelectComponent } from '@xenial-ux/xux-input-select';
import { XuxWidgetBoilerplateComponent } from '@xenial-ux/xux-widget-boilerplate';
import { XuxDynamicWidgetWrapperComponent } from '@xenial-ux/xux-dynamic-widget';
import { XuxHintComponent } from '@xenial-ux/xux-hint';
import { XuxInfoBlockComponent } from '@xenial-ux/xux-info-block';
import { TranslateModule } from '@ngx-translate/core';
import { XUXLoaderSmallComponent } from './xux-loader-small';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        DmComponentsModule,
        BsDatepickerModule.forRoot(),
        BsDropdownModule.forRoot(),
        XUXDrawerModule.forRoot(),
        FocusElementModule,
        TranslateModule,
    ],
    declarations: [
        XUXBreadcrumbNavbarComponent,
        XuxSearchInputComponent,
        XuxModalInputComponent,
        ...datePickerComponents,
        XuxIconDefsComponent,
        XuxWidgetBoilerplateComponent,
        XuxDynamicWidgetWrapperComponent,
        XuxHintComponent,
        XuxInfoBlockComponent,
        XuxInputSelectComponent,
        XuxIconComponent,
        XUXLoaderSmallComponent,
    ],
    exports: [
        DmComponentsModule,
        BsDatepickerModule,
        XuxModalInputComponent,
        XuxSearchInputComponent,
        XUXBreadcrumbNavbarComponent,
        XuxDatepickerLayoutComponent,
        XuxDatepickerInputComponent,
        XuxWidgetBoilerplateComponent,
        XuxDynamicWidgetWrapperComponent,
        XuxHintComponent,
        XuxInfoBlockComponent,
        XuxInputSelectComponent,
        XuxIconComponent,
        XUXLoaderSmallComponent,
        XUXDrawerModule,
        XuxIconDefsComponent,
    ],
    providers: []
})
export class XenialUxModule {
    public static forRoot(): ModuleWithProviders<XenialUxModule> {
        return {
            ngModule: XenialUxModule,
            providers: [XUXMenuPinnedService, XUXDrawerSidebarService]
        };
    }
}
